import { ROLE } from "~/assets/js/constants";

type ACL = {
  allowedTo?: ROLE[];
  forbiddenTo?: ROLE[];
};

export default function ({ store, route, redirect }) {
  const meta = Array.isArray(route.meta)
    ? route.meta.find((m: Record<string, unknown>) => m && m.acl)
    : route.meta;
  const acl = meta?.acl as ACL | undefined;

  if (!acl || (!acl.allowedTo && !acl.forbiddenTo)) {
    throw new Error("Not configured. Include a properly configured acl property in meta");
  }

  const { allowedTo, forbiddenTo } = acl;
  const loggedRole = store.getters["application/getLoggedRole"];

  if (allowedTo && !allowedTo.includes(loggedRole)) {
    return redirect("/");
  }
  if (forbiddenTo && forbiddenTo.includes(loggedRole)) {
    return redirect("/");
  }
}
